module.exports = __webpack_public_path__ + "static/media/practice-question-popup-header.8f6f9a67.png";